import styles from "./pollsuccess.module.css";

export default function PollSuccess() {
  return (
    <>
      <div className={styles.poll_success_container}>
        <div className={styles.card}><div className={styles.icon}>✓</div><p className={styles.kicker}>RESPONSE RECORDED</p><h1>Thanks for participating!</h1><p>Your vote has been counted successfully. You can safely close this page.</p></div>
      </div>
    </>
  );
}
